// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b1f42298","732":"7758b574","977":"5de50dfc"}[chunkId] + ".chunk.js";
};